<template>
  <BaseButton
    class="article-button"
    :class="{ 'full-width': $isAMP }"
    :disabled="!props.href"
    :href="props.href"
    :rel="props.href ? props.rel : null"
    :target="props.target ? props.target : null"
  >
    <slot />
  </BaseButton>
</template>

<script lang="ts" setup>
  import BaseButton from '@devhacker/shared/components/base/BaseButton.vue';

  const { $isAMP } = useNuxtApp();

  const props = defineProps({
    href: {
      type: String,
      default: null,
    },
    rel: {
      type: String,
      default: null,
    },
    target: {
      type: String,
      default: null,
    },
  });
</script>

<style lang="scss" scoped>
  .article-button {
    &.full-width {
      width: 100%;
    }
  }
</style>
